import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _URL from "@babel/runtime-corejs3/core-js-stable/url";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { fileNameFromUrl } from "utils/fileUrl";

/**
 * Fetches a signed file URL and saves it through a temporary `<a download>`, so the browser names
 * the file `fileLabel` instead of the storage key. A plain `GET` with no custom headers, so the
 * cross-origin request needs no CORS preflight; and no `HEAD` probe, which some signed URLs
 * reject (see docs/gotchas.md).
 *
 * Resolves `false` when nothing was saved, so a caller can tell the user: a failed request starts
 * no download, and the browser shows nothing on its own.
 */
export var downloadFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(signedUrl, fileLabel) {
    var response, blob, url, a, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 1;
          return window.fetch(signedUrl);
        case 1:
          response = _context.sent;
          if (response.ok) {
            _context.next = 2;
            break;
          }
          throw new Error("Download failed with ".concat(response.status));
        case 2:
          _context.next = 3;
          return response.blob();
        case 3:
          blob = _context.sent;
          url = _URL.createObjectURL(blob);
          a = document.createElement("a");
          a.href = url;
          // `fileLabel` is typed `string`, but legacy callers can still pass a null label through.
          a.download = fileLabel !== null && fileLabel !== void 0 ? fileLabel : fileNameFromUrl(signedUrl);
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove();
          // Deferred: the browser resolves the blob URL after `click()` returns, and revoking it in
          // the same tick can cancel the download (Safari, some Firefox). The bytes are already in
          // memory, so the delay only has to outlast that lookup; 40s is FileSaver.js's margin.
          _setTimeout(function () {
            return _URL.revokeObjectURL(url);
          }, 40000);
          return _context.abrupt("return", true);
        case 4:
          _context.prev = 4;
          _t = _context["catch"](0);
          // eslint-disable-next-line no-console
          console.error(_t);
          return _context.abrupt("return", false);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 4]]);
  }));
  return function downloadFile(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();